jQuery(document).ready(function($) {
	$('.m-gallery__main').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		fade: true,
		dots: true,
		adaptiveHeight: true,
		customPaging: function(slick,index) {
	    var targetImage = slick.$slides.eq(index).find('img').attr('src') || '';
	    return '<div style="background-image: url('+ targetImage +');"></div>';
		}
	});

});
